// M4-A3 — Hardware back button Android (SOLO runtime Capacitor). Additivo: nessun effetto sul web.
// Non tocca Router/Auth/Stripe. Import dinamico: il plugin nativo non entra nel path web.
let _registered = false;

export async function initMobileBackButton() {
  const Cap = window.Capacitor;
  if (!Cap || typeof Cap.isNativePlatform !== "function" || !Cap.isNativePlatform()) return;
  if (_registered) return; // un solo listener, mai doppio
  try {
    const { App } = await import("@capacitor/app");
    App.addListener("backButton", ({ canGoBack }) => {
      // canGoBack riflette la history della WebView (SPA React history inclusa).
      // Se c'e' history interna significativa -> torna indietro; altrimenti esci (root/Home).
      if (canGoBack || window.history.length > 1) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });
    _registered = true;
  } catch (e) {
    /* plugin @capacitor/app non disponibile: non bloccante */
  }
}
